const customBackgroundByUser = [
    {
        "id": "NNING",
        "html": "",
        "css": `
            @font-face {
                font-family: "Geist";
                src: url("https://assets.codepen.io/605876/GeistVF.ttf") format("truetype");
            }
            
            :root {
                --size: 20px;
            }

            .musicardContainer .customBackground {
                position: fixed;
                top: 0;
                left: -100%;
                z-index: 1;
                width: 400%;
                height: 400vh;
                background: conic-gradient(from 180deg at 50% 70%,hsla(0,0%,98%,1) 0deg,#eec32d 72.0000010728836deg,#ec4b4b 144.0000021457672deg,#709ab9 216.00000858306885deg,#4dffbf 288.0000042915344deg,hsla(0,0%,98%,1) 1turn);
                mask:
                    radial-gradient(circle at 50% 50%, white 2px, transparent 2.5px) 50% 50% / var(--size) var(--size),
                    url("https://assets.codepen.io/605876/noise-mask.png") 256px 50% / 256px 256px;
                mask-composite: intersect;
                animation: flicker 20s infinite linear;
            }
            
            @keyframes flicker {
                to {
                    mask-position: 50% 50%, 0 50%;
                }
            }`,
        "js": "setTimeout(() => { customScript(); }, 200); function customScript() {let getNameElement = document.querySelector('.name .customName'); let getName = getNameElement.innerText;let nameArray = getName.split('');getNameElement.innerHTML = '';for (let i = 0; i < nameArray.length; i++) {let span = document.createElement('span');span.classList.add('letter');span.classList.add('letter-'+ (i + 1));span.innerText = nameArray[i];getNameElement.appendChild(span); }}",
        "nameHtml": `<div class="customName">[MUSICIAN_NAME]</div>`,
        "nameStyle": `
            @font-face {
                font-family: "Liberty";
                src: url('https://s3-us-west-2.amazonaws.com/s.cdpn.io/907368/liberty.otf');
            }
            .customName {
                font-family: 'Liberty';
                font-weight: 100;
                font-size: 30px;
                letter-spacing: 0;
                flex-flow: row;
            }
            .customName .letter {
                color: #d9fdff;
                text-shadow: 0 0 2rem #00f0ff;
                display: inline-block;
            }


            .customName .letter.letter-2 {
                transform: translate(-0.2rem, 1rem) rotate(10deg);
                animation: flicker 2s ease-in-out infinite alternate;
            }

            @keyframes flicker {
                0% {
                    opacity: 1;
                    transform: translate(-0.2rem, 1rem) rotate(10deg);
                }
                5% {
                    opacity: 1;
                    transform: translate(-0.2rem, 1rem) rotate(10deg);
                }
                5.5% {
                    opacity: 0;
                    transform: translate(-0.2rem, 1rem) rotate(10deg);
                }
                6%{
                    opacity: 1;
                    transform: translate(-0.2rem, 1rem) rotate(10deg);}
                6.5%{
                    opacity: 1;
                    transform: translate(-0.2rem, 1rem) rotate(10deg);}
                7%{
                    opacity: 0;
                    transform: translate(-0.2rem, 1rem) rotate(10deg);}
                8%{
                    opacity: 1;
                    transform: translate(-0.2rem, 1rem) rotate(10deg);}
                50%{
                    opacity: 1;
                    transform: translate(-0.2rem, 1rem) rotate(13deg);}
                100%{
                    opacity: 1;
                    transform: translate(-0.2rem, 1rem) rotate(10deg);}
            }`
    },
    {
        "id": "KyuJoonJeong",
        "html": "<div class='elements'><div class='square sq1'></div><div class='square sq2'></div><div class='square sq3'></div></div>",
        "css": ".customBackground { animation: pulse 5s infinite; overflow: hidden; } @keyframes pulse { 0% {background: #000000;} 50% {background: #000000;} 100% {background: #000000;} } .elements { height: 100vh; display: flex; flex-flow: row nowrap; justify-content: space-around; align-items: center; } .square { border: 1px dashed #ffffff; } .sq2 { animation: move1 180s infinite; animation-timing-function: linear; width: 1110px; height: 1110px; } @keyframes move1 { 0% { transform: rotate(0deg); opacity: 0.2; } 50% { width: 1000px; height: 1000px; } 100% { transform: rotate(1000deg); opacity: 1; } } .sq3 { width: 600px; height: 600px; animation: move1 120s infinite; animation-timing-function: linear; } .sq1 { width: 500px; height: 500px; animation: move1 100s infinite; animation-timing-function: linear; } @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@100&display=swap'); .name h1 { min-width: fit-content; margin: auto; font-size: 35px; font-weight: 400; color: white; letter-spacing: 0.1cm; } .name > h1 { line-height: 0.8; } .name * { font-family: 'MapoDPPA', sans-serif !important; } .reflection { -moz-transform: scale(1, -1); -webkit-transform: scale(1, -1); -o-transform: scale(1, -1); -ms-transform: scale(1, -1); transform: scale(1, -1); color: gray; } .fade--effect { position: absolute; background-color: black; width: 100%; height: calc(2 * 100%); top: 10%; background: linear-gradient( 0deg, rgba(0, 0, 0, 1) 65%, rgba(0, 0, 0, 0.9) 80%, rgba(0, 0, 0, 0.25) 95%, rgba(0, 0, 0, 0) 100% ); } .reflection--container { position: relative; }",
        "js": "",
        'nameHtml': "<h1>[MUSICIAN_NAME]</h1><div class='reflection--container'><h1 class='reflection'>[MUSICIAN_NAME]</h1><div class='fade--effect'></div></div>",
        'nameStyle': ""
    },
    {
        "id": "SiAN",
        "html": `<canvas id="canvas">Canvas not supported.</canvas>`,
        "css": `
            .customBackground {
                position: relative;
                width: 100%;
                background: linear-gradient(to bottom, #4A74A8 30%, #3B5290 50%, #222254 80%) !important;
                filter: blur(4px);
            }
            .customBackground canvas#canvas {
                display: block;
            }
        `,
        "js": `
            setTimeout(() => { customScript() }, 500);
            function customScript() {
                var canvas = document.getElementById('canvas');
        
                if (!canvas || !canvas.getContext) {
                    return false;
                }

                /********************
                 Random Number
                ********************/

                function rand(min, max) {
                    return Math.floor(Math.random() * (max - min + 10) + min);
                }

                /********************
                 Var
                ********************/

                var ctx = canvas.getContext('2d');
                var X = canvas.width = window.innerWidth;
                var Y = canvas.height = window.innerHeight;
                var mouseX = null;
                var mouseY = null;
                var shapeNum = 300;
                var shapes = [];
                var style = {
                    black: 'black',
                    white: 'white',
                    lineWidth: 4,
                };

                /********************
                 Animation
                ********************/

                window.requestAnimationFrame =
                window.requestAnimationFrame ||
                window.mozRequestAnimationFrame ||
                window.webkitRequestAnimationFrame ||
                window.msRequestAnimationFrame ||

                function(cb) {
                    setTimeout(cb, 17);
                };

                /********************
                 Shape
                ********************/

                function Shape(ctx, x, y) {
                    this.ctx = ctx;
                    this.init(x, y);
                }

                Shape.prototype.init = function(x, y) {
                    this.x = x;
                    this.y = y;
                    this.r = rand(5, 15);
                    this.ga = Math.random() * Math.random() * Math.random() * Math.random();
                    this.v = {
                        x: Math.random(),
                        y: -1
                    };
                    this.l = rand(0, 200);
                    this.sl = this.l;
                    };

                    Shape.prototype.updateParams = function() {
                    var ratio = this.l / this.sl;
                    //this.r *= ratio;
                    this.l -= 1;
                    if (this.l < 0) {
                        this.init(X * (Math.random() + Math.random()) / 2, rand(0, Y));
                    }
                };

                Shape.prototype.updatePosition = function() {
                    this.x += Math.random();
                    this.y += -Math.random();
                };

                Shape.prototype.draw = function() {
                    var ctx  = this.ctx;
                    ctx.save();
                    ctx.globalCompositeOperation = 'lighter';
                    ctx.globalAlpha = this.ga;
                    ctx.fillStyle = 'white';
                    ctx.beginPath();
                    ctx.arc(this.x, this.y, this.r, 0, Math.PI * 2, false);
                    ctx.fill();
                    ctx.restore();
                };

                Shape.prototype.render = function(i) {
                    this.updatePosition();
                    this.updateParams();
                    this.draw();
                };

                for (var i = 0; i < shapeNum; i++) {
                    var s = new Shape(ctx, X * (Math.random() + Math.random()) / 2, rand(0, Y));
                    shapes.push(s);
                }

                /********************
                 Render
                ********************/

                function render() {
                    ctx.clearRect(0, 0, X, Y);
                    for (var i = 0; i < shapes.length; i++) {
                        shapes[i].render(i);
                    }
                    requestAnimationFrame(render);
                }

                render();

                /********************
                 Event
                ********************/

                function onResize() {
                    X = canvas.width = window.innerWidth;
                    Y = canvas.height = window.innerHeight;
                }

                window.addEventListener('resize', function() {
                    onResize();
                });

                window.addEventListener('mousemove', function(e) {
                    mouseX = e.clientX;
                    mouseY = e.clientY;
                }, false);
            }`,
        "nameHtml": `
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                width="134px" height="60px" xml:space="preserve">
            <defs>
                <pattern id="water" width=".25" height="1.1" patternContentUnits="objectBoundingBox">
                <path fill="#0f99bf" d="M0.25,1H0c0,0,0-0.659,0-0.916c0.083-0.303,0.158,0.334,0.25,0C0.25,0.327,0.25,1,0.25,1z"/>
                </pattern>
                <text id="text" transform="translate(20,116)" font-size="40" dy="-60" style="font-weight: bold;">[MUSICIAN_NAME]</text>
                <mask id="text-mask">
                    <use x="0" y="0" xlink:href="#text" opacity="1" fill="#ffffff"/>
                </mask>
                <g id="eff">
                <use x="0" y="0" xlink:href="#text" fill="#ccd9fc"/>
                <rect class="water-fill" mask="url(#text-mask)" fill="url(#water)" x="-300" y="85" width="1200" height="80" opacity="0.3">
                    <animate attributeType="xml" attributeName="x" from="-300" to="0" repeatCount="indefinite" dur="2s"/>
                </rect>
                <rect class="water-fill" mask="url(#text-mask)" fill="url(#water)" y="40" width="1600" height="80" opacity="0.3">
                    <animate attributeType="xml" attributeName="x" from="-400" to="0" repeatCount="indefinite" dur="3s"/>
                </rect>
                <rect class="water-fill" mask="url(#text-mask)" fill="url(#water)" y="50" width="800" height="80" opacity="0.3">
                    <animate attributeType="xml" attributeName="x" from="-200" to="0" repeatCount="indefinite" dur="1.4s"/>
                </rect>
                    <rect class="water-fill" mask="url(#text-mask)" fill="url(#water)" y="95" width="2000" height="80" opacity="0.3">
                    <animate attributeType="xml" attributeName="x" from="-500" to="0" repeatCount="indefinite" dur="2.8s"/>
                </rect>
                    </g>
                </defs>
                <use xlink:href="#eff" opacity="0.9" style="mix-blend-mode:color-burn"/>
            </svg>
        `,
    },
    {
        "id": "R.park",
        "html": "<canvas id='c'></canvas>",
        "css": `canvas {
            margin: 0;
            padding: 0;
            height: 100%;
            width: 100%;
            display: block; 
            position: absolute;
            background: -moz-radial-gradient(center, ellipse cover, rgba(70,110,190,0.6) 0%, rgba(40,70,140,0.8) 100%); /* FF3.6+ */
            background: -webkit-gradient(radial, center center, 0px, center center, 100%, color-stop(0%, rgba(70,110,190,0.6)), color-stop(100%, rgba(40,70,140,0.8))); /* Chrome,Safari4+ */
            background: -webkit-radial-gradient(center, ellipse cover, rgba(70,110,190,0.6) 0%, rgba(40,70,140,0.8) 100%); /* Chrome10+,Safari5.1+ */
            background: -o-radial-gradient(center, ellipse cover, rgba(70,110,190,0.6) 0%, rgba(40,70,140,0.8) 100%); /* Opera 12+ */
            background: -ms-radial-gradient(center, ellipse cover, rgba(70,110,190,0.6) 0%, rgba(40,70,140,0.8) 100%); /* IE10+ */
            background: radial-gradient(ellipse at center, rgba(70,110,190,0.6) 0%, rgba(40,70,140,0.8) 100%); /* W3C */
            filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#80abd1ea', endColorstr='#bf7db9e8',GradientType=1 ); /* IE6-9 fallback on horizontal gradient */
            }
            .musicardContainer .name .sign { min-height: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center; } .musicardContainer .name .sign span { font-size: inherit; text-align: center; line-height: 1; color: #F7F7F7; animation: neon .08s ease-in-out infinite alternate; } @keyframes neon { from { text-shadow: 0 0 6px rgba(202,228,225,0.92), 0 0 30px rgba(202,228,225,0.34), 0 0 12px rgba(30,132,242,0.52), 0 0 21px rgba(30,132,242,0.92), 0 0 34px rgba(30,132,242,0.78), 0 0 54px rgba(30,132,242,0.92); } to { text-shadow: 0 0 6px rgba(202,228,225,0.98), 0 0 30px rgba(202,228,225,0.42), 0 0 12px rgba(30,132,242,0.58), 0 0 22px rgba(30,132,242,0.84), 0 0 38px rgba(30,132,242,0.88), 0 0 60px rgba(30,132,242,1); } }
        `,
        "js": `
            //setTimeoue needed to get full screen canvas
            setTimeout(function () {
            function resizeCanvas() {
                ch = window.innerHeight;
                cw = window.innerWidth;
                c.width = cw;
                c.height = ch;
            }

            var cw,
                ch,
                c = document.getElementById("c"),
                ctx = c.getContext("2d"),
                parts = [],
                globalTick = 0,
                rand = function (min, max) {
                return Math.floor(Math.random() * (max - min + 1) + min);
                };

            var Part = function () {
                this.reset();
            };

            Part.prototype.reset = function () {
                this.startRadius = rand(1, 10);
                // this.startRadius = rand(20, 25);
                this.radius = this.startRadius;
                this.x = rand(0, c.width);
                this.y = rand(0, c.height);
                this.hue = 210;
                this.saturation = rand(40, 60);
                this.lightness = rand(70, 80);
                this.startAlpha = 0.5;
                this.alpha = this.startAlpha;
                this.decayRate = 0.3;
                this.startLife = rand(20, 30);
                // this.startLife = 15;
                this.life = this.startLife;
                this.lineWidth = 1;
            };

            Part.prototype.update = function () {
                this.alpha = this.startAlpha * (this.life / this.startLife);
                this.radius = this.radius + 1;
                this.life -= this.decayRate;
            };

            Part.prototype.render = function () {
                ctx.beginPath();
                ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2, false);
                ctx.fillStyle = ctx.strokeStyle =
                "hsla(" +
                this.hue +
                ", " +
                this.saturation +
                "%, " +
                this.lightness +
                "%, " +
                this.alpha +
                ")";
                ctx.lineWidth = this.lineWidth;
                ctx.fill();
                // ctx.stroke();
            };

            var createParts = function () {
                parts.push(new Part());
            };

            var updateParts = function () {
                var i = parts.length;
                while (i--) {
                if (parts[i].life < 0) {
                    parts.splice(i, 1);
                }
                parts[i].update();
                }
            };

            var renderParts = function () {
                var i = parts.length;
                while (i--) {
                parts[i].render();
                }
            };

            var clear = function () {
                ctx.globalCompositeOperation = "destination-out";
                ctx.fillStyle = "hsla(0, 0%, 0%, 1)";
                ctx.fillRect(0, 0, cw, ch);
                ctx.globalCompositeOperation = "source-over";
            };

            //Run through the first iterations to get all the parts ready for rendering.
            for (i = 0; i < 200; i++) {
                if (globalTick % 6 == 0) {
                createParts();
                }
                updateParts();
                globalTick++;
            }

            var loop = function () {
                window.requestAnimFrame(loop, c);
                clear();

                if (globalTick % 6 == 0) {
                createParts();
                }

                updateParts();
                renderParts();
                globalTick++;
            };

            window.requestAnimFrame = (function () {
                return (
                window.requestAnimationFrame ||
                window.webkitRequestAnimationFrame ||
                window.mozRequestAnimationFrame ||
                window.oRequestAnimationFrame ||
                window.msRequestAnimationFrame ||
                function (a) {
                    window.setTimeout(a, 1e3 / 60);
                }
                );
            })();

            resizeCanvas();
            window.onresize = resizeCanvas;

            loop();
            }, 100);
        `,
        "nameHtml": "<div class='sign'><span>[MUSICIAN_NAME]</span></div>",
        "nameStyle": ""
    },
    {
        "id": "Dj.Girin",
        "html": "<div class='particles'><span class='circle' id='circle-1'></span><span class='circle' id='circle-2'></span><span class='circle' id='circle-3'></span><span class='circle' id='circle-4'></span><span class='circle' id='circle-5'></span><span class='circle' id='circle-6'></span><span class='circle' id='circle-7'></span><span class='circle' id='circle-8'></span><span class='circle' id='circle-9'></span><span class='circle' id='circle-10'></span><span class='circle' id='circle-11'></span><span class='circle' id='circle-12'></span><span class='circle' id='circle-13'></span><span class='circle' id='circle-14'></span><span class='circle' id='circle-15'></span><span class='circle' id='circle-16'></span><span class='circle' id='circle-17'></span><span class='circle' id='circle-18'></span><span class='circle' id='circle-19'></span><span class='circle' id='circle-20'></span><span class='circle' id='circle-21'></span><span class='circle' id='circle-22'></span><span class='circle' id='circle-23'></span><span class='circle' id='circle-24'></span><span class='circle' id='circle-25'></span><span class='circle' id='circle-26'></span><span class='circle' id='circle-27'></span><span class='circle' id='circle-28'></span><span class='circle' id='circle-29'></span><span class='circle' id='circle-30'></span><span class='circle' id='circle-31'></span><span class='circle' id='circle-32'></span><span class='circle' id='circle-33'></span><span class='circle' id='circle-34'></span><span class='circle' id='circle-35'></span><span class='circle' id='circle-36'></span><span class='circle' id='circle-37'></span><span class='circle' id='circle-38'></span><span class='circle' id='circle-39'></span><span class='circle' id='circle-40'></span></div>",
        "css": ".particle-container { background-color: #f9ecd0; position: relative; height: 100vh; } .particles { position: relative; width: 100%; height: 100%; } .circle { border-radius: 50%; position: absolute; z-index: 12; } @keyframes particle-animation {0% {transform: translate3d(0, 0, 0) rotate(0deg);}100% {transform: translate3d(100vw, 100vh, 0) rotate(360deg);}} @keyframes fade-frames {0%{opacity: 0;}25%{opacity: 0.5;}100% {opacity: 1;}75%{opacity: 0.5;}100%{opacity: 0;}} .key {font-size: inherit;display: inline-block; color: #000000 !important; letter-spacing: 0.35px;transition: transform 0.2s;} @keyframes pressDown1 {30%,40%,100% {transform: translateY(0);}35% {transform: translateY(10px);}} @keyframes pressDown2 {70%,80%,100% {transform: translateY(0);}75% {transform: translateY(10px);}} @keyframes pressDown3 {30%,40%,100% {transform: translateY(0);}35% {transform: translateY(10px);}} @keyframes pressDown4 {40%,50%,100% {transform: translateY(0);}45% {transform: translateY(10px);}} @keyframes pressDown5 {20%,30%,100% {transform: translateY(0);}25% {transform: translateY(10px);}} @keyframes pressDown6 {60%,70%,100% {transform: translateY(0);}65% {transform: translateY(10px);}} @keyframes pressDown7 {10%,20%,100% {transform: translateY(0);}15% {transform: translateY(10px);}} @keyframes pressDown8 {35%,45%,100% {transform: translateY(0);}40% {transform: translateY(10px);}} .key:nth-child(1) {animation: pressDown1 2s infinite;} .key:nth-child(2) {animation: pressDown2 3s infinite;} .key:nth-child(3) {animation: pressDown3 4s infinite;} .key:nth-child(4) {animation: pressDown4 2.5s infinite;} .key:nth-child(5) {animation: pressDown5 2.5s infinite;} .key:nth-child(6) {animation: pressDown6 3.5s infinite;} .key:nth-child(7) {animation: pressDown7 2.2s infinite;} .key:nth-child(8) {animation: pressDown8 3.2s infinite;}",
        "js": "setTimeout(() => { customScript(); customScript2(); }, 100);function customScript() {const circles = document.querySelectorAll('.circle');circles.forEach((circle, index) => {const size = Math.random() * 100 + 5;const color = Math.floor(Math.random() * 256);const delay = -index * 0.2 + 's';circle.style.width = size + 'px';circle.style.height = size + 'px';circle.style.backgroundColor = 'rgb(' + color + ', ' + color + ', ' + color + ')';circle.style.animation = 'fade-frames 10s ease-in-out infinite';circle.style.animationDelay = delay;circle.style.transition = 'transform 7s linear';function randomizePosition() {const x = Math.random() * 110;const y = Math.random() * 100;const z = Math.random() * 400;const rotation = Math.random() * 90;const transform = 'translate3d(' + x + 'vw, ' + y + 'vh, ' + z + 'px) rotate(' + rotation + 'deg)';circle.style.transform = transform;}setInterval(randomizePosition, 7000);randomizePosition();});} function customScript2() {let getNameElement = document.querySelector('.name .keyboard');let getName = getNameElement.innerText;let nameArray = getName.split('');getNameElement.innerHTML = '';for (let i = 0; i < nameArray.length; i++) {let span = document.createElement('span');span.classList.add('key');span.innerText = nameArray[i];getNameElement.appendChild(span);}}",
        "nameHtml": "<div class='keyboard'>[MUSICIAN_NAME]</div>",
        "nameStyle": ""
    },
    {
        "id": "SeyanKim",
        "html": "<div class='space'></div>",
        "css": "/* Animations */ @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } } /* Space */ .space { position: absolute; width: 400vw; height: 400vh; top: 50%; left: 50%; margin-top: -200vh; margin-left: -200vw; animation: spin 240s linear infinite; background-size: 240px; backface-visibility: visible; /* Had to base64 SVG background for FF compatibility */ background-image: url(data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8yIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDI0MCAyNDAiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDI0MCAyNDAiIHhtbDpzcGFjZT0icHJlc2VydmUiPjxyZWN0IHg9IjEwNiIgeT0iOTAiIGZpbGw9IiNGRkZGRkYiIHdpZHRoPSIyIiBoZWlnaHQ9IjIiLz48cmVjdCB4PSI3NCIgeT0iNjMiIGZpbGw9IiNGRkZGRkYiIHdpZHRoPSIxIiBoZWlnaHQ9IjEiLz48cmVjdCB4PSIyMyIgeT0iNjYiIGZpbGw9IiNGRkZGRkYiIHdpZHRoPSIxIiBoZWlnaHQ9IjEiLz48cmVjdCB4PSI1MCIgeT0iMTEwIiBmaWxsPSIjRkZGRkZGIiB3aWR0aD0iMSIgaGVpZ2h0PSIxIi8+PHJlY3QgeD0iNjMiIHk9IjEyOCIgZmlsbD0iI0ZGRkZGRiIgd2lkdGg9IjEiIGhlaWdodD0iMSIvPjxyZWN0IHg9IjQ1IiB5PSIxNDkiIGZpbGw9IiNGRkZGRkYiIHdpZHRoPSIxIiBoZWlnaHQ9IjEiLz48cmVjdCB4PSI5MiIgeT0iMTUxIiBmaWxsPSIjRkZGRkZGIiB3aWR0aD0iMSIgaGVpZ2h0PSIxIi8+PHJlY3QgeD0iNTgiIHk9IjgiIGZpbGw9IiNGRkZGRkYiIHdpZHRoPSIxIiBoZWlnaHQ9IjEiLz48cmVjdCB4PSIxNDciIHk9IjMzIiBmaWxsPSIjRkZGRkZGIiB3aWR0aD0iMiIgaGVpZ2h0PSIyIi8+PHJlY3QgeD0iOTEiIHk9IjQzIiBmaWxsPSIjRkZGRkZGIiB3aWR0aD0iMSIgaGVpZ2h0PSIxIi8+PHJlY3QgeD0iMTY5IiB5PSIyOSIgZmlsbD0iI0ZGRkZGRiIgd2lkdGg9IjEiIGhlaWdodD0iMSIvPjxyZWN0IHg9IjE4MiIgeT0iMTkiIGZpbGw9IiNGRkZGRkYiIHdpZHRoPSIxIiBoZWlnaHQ9IjEiLz48cmVjdCB4PSIxNjEiIHk9IjU5IiBmaWxsPSIjRkZGRkZGIiB3aWR0aD0iMSIgaGVpZ2h0PSIxIi8+PHJlY3QgeD0iMTM4IiB5PSI5NSIgZmlsbD0iI0ZGRkZGRiIgd2lkdGg9IjEiIGhlaWdodD0iMSIvPjxyZWN0IHg9IjE5OSIgeT0iNzEiIGZpbGw9IiNGRkZGRkYiIHdpZHRoPSIzIiBoZWlnaHQ9IjMiLz48cmVjdCB4PSIyMTMiIHk9IjE1MyIgZmlsbD0iI0ZGRkZGRiIgd2lkdGg9IjIiIGhlaWdodD0iMiIvPjxyZWN0IHg9IjEyOCIgeT0iMTYzIiBmaWxsPSIjRkZGRkZGIiB3aWR0aD0iMSIgaGVpZ2h0PSIxIi8+PHJlY3QgeD0iMjA1IiB5PSIxNzQiIGZpbGw9IiNGRkZGRkYiIHdpZHRoPSIxIiBoZWlnaHQ9IjEiLz48cmVjdCB4PSIxNTIiIHk9IjIwMCIgZmlsbD0iI0ZGRkZGRiIgd2lkdGg9IjEiIGhlaWdodD0iMSIvPjxyZWN0IHg9IjUyIiB5PSIyMTEiIGZpbGw9IiNGRkZGRkYiIHdpZHRoPSIyIiBoZWlnaHQ9IjIiLz48cmVjdCB5PSIxOTEiIGZpbGw9IiNGRkZGRkYiIHdpZHRoPSIxIiBoZWlnaHQ9IjEiLz48cmVjdCB4PSIxMTAiIHk9IjE4NCIgZmlsbD0iI0ZGRkZGRiIgd2lkdGg9IjEiIGhlaWdodD0iMSIvPjwvc3ZnPg==); } .musicardContainer .nameBackground { background: 50% 100% / 50% 50% no-repeat radial-gradient(ellipse at bottom, #fff, transparent, transparent); -webkit-background-clip: text; background-clip: text; color: transparent; font-size: 30px; font-family: 'SangSangYoungestDaughter', sans-serif; animation: reveal 3000ms ease-in-out forwards 200ms, glow 2500ms linear infinite 2000ms; } @keyframes reveal { 80% { letter-spacing: 8px; } 100% { background-size: 300% 300%; } } @keyframes glow { 40% { text-shadow: 0 0 8px #fff; } }",
        "js":"",
        "nameHtml": "<div class='nameBackground'>[MUSICIAN_NAME]</div>",
        "nameStyle": ""
    },
    {
        "id": "REDDOVE",
        "html": "<div id='stars'></div><div id='stars2'></div><div id='stars3'></div>",
        "css": "@import url('https://fonts.googleapis.com/css2?family=Raleway:wght@300&display=swap'); #stars, #stars2, #stars3 { position: absolute; top: 0; left: 0; animation: animStar linear infinite; } #stars { width: 1px; height: 1px; background: transparent; animation-duration: 50s; } #stars2 { width: 2px; height: 2px; background: transparent; animation-duration: 100s; } #stars3 { width: 3px; height: 3px; background: transparent; animation-duration: 150s; } @keyframes animStar { from { transform: translateY(0px); } to { transform: translateY(-2000px); } } h1.name { margin: auto; font-size: 3.5rem; font-weight: 300; animation: lights 5s 750ms linear infinite; } @keyframes lights { 0% { text-shadow: 0 0 1em hsla(0, 70%, 60%, 0.2), 0 0 0.125em hsla(0, 70%, 70%, 0.3), -1em -0.125em 0.5em hsla(0, 70%, 70%, 0), 1em 0.125em 0.5em hsla(0, 70%, 70%, 0); } 30% { text-shadow: 0 0 1em hsla(0, 70%, 60%, 0.5), 0 0 0.125em hsla(0, 70%, 70%, 0.5), -0.5em -0.125em 0.25em hsla(0, 70%, 70%, 0.2), 0.5em 0.125em 0.25em hsla(0, 70%, 70%, 0.4); } 40% { text-shadow: 0 0 1em hsla(0, 70%, 60%, 0.5), 0 0 0.125em hsla(0, 70%, 80%, 0.5), -0.25em -0.125em 0.125em hsla(0, 70%, 70%, 0.2), 0.25em 0.125em 0.125em hsla(0, 70%, 70%, 0.4); } 70% { text-shadow: 0 0 1em hsla(0, 70%, 60%, 0.5), 0 0 0.125em hsla(0, 70%, 70%, 0.5), 0.5em -0.125em 0.25em hsla(0, 70%, 70%, 0.2), -0.5em 0.125em 0.25em hsla(0, 70%, 70%, 0.4); } 100% { text-shadow: 0 0 1em hsla(0, 70%, 60%, 0.2), 0 0 0.125em hsla(0, 70%, 70%, 0.3), 1em -0.125em 0.5em hsla(0, 70%, 70%, 0), -1em 0.125em 0.5em hsla(0, 70%, 70%, 0); } }",
        "js": "setTimeout(() => { customScript(); }, 200); function generateBoxShadow(n, max = 2000) { let shadow = ''; for (let i = 0; i < n; i++) { const x = Math.floor(Math.random() * max); const y = Math.floor(Math.random() * max); shadow += x + 'px ' + y + 'px #FFF'; if (i < n - 1) { shadow += ', '; } } return shadow; } function customScript() { const styleSheet = document.querySelector('#custom-style'); const starsSmall = document.querySelector('#stars'); const starsMedium = document.querySelector('#stars2'); const starsBig = document.querySelector('#stars3'); starsSmall.style.boxShadow = generateBoxShadow(700); starsMedium.style.boxShadow = generateBoxShadow(200); starsBig.style.boxShadow = generateBoxShadow(100); const afterStyleSmall = 'content: ` `; position: absolute; top: 2000px; width: 1px; height: 1px; background: transparent; box-shadow: ' + generateBoxShadow(700) + ';'; const afterStyleMedium = 'content: ` `; position: absolute; top: 2000px; width: 2px; height: 2px; background: transparent; box-shadow: ' + generateBoxShadow(200) + ';'; const afterStyleBig = 'content: ` `; position: absolute; top: 2000px; width: 3px; height: 3px; background: transparent; box-shadow: ' + generateBoxShadow(100) +';'; styleSheet.innerText += '#stars:after { ' + afterStyleSmall + ' }'; styleSheet.innerText += '#stars2:after { ' + afterStyleMedium + ' }'; styleSheet.innerText += '#stars3:after { ' + afterStyleBig + ' }'; }",
        "nameHtml": "",
        "nameStyle": ""
    },
    {
        "id": "Luog",
        "html": "<article id='wrap'><article id='lightings'><section id='one'><section id='two'><section id='three'><section id='four'><section id='five'></section></section></section></section></section></article></article>",
        "css": "#wrap { width: 200%; height: 100%; position: relative;  overflow: hidden;     width: 100%;             margin: 0 0 0 auto; }     @media (max-width: 1024px) {         #wrap {             width: 100%;             margin: 0 auto 0 auto;         }     }  #lightings { bottom: 400px; position: absolute; width: 100%; }  section { /*border-radius*/ -webkit-border-radius: 50%; -moz-border-radius: 50%; border-radius: 50%; height: 0; width: 100%; position: relative; margin: auto; }  #one {  -webkit-animation: one 5s ease-in-out infinite alternate; -moz-animation: one 5s ease-in-out infinite alternate; -ms-animation: one 5s ease-in-out infinite alternate; -o-animation: one 5s ease-in-out infinite alternate; animation: one 5s ease-in-out infinite alternate; } @-webkit-keyframes  one { from { -webkit-box-shadow: 0 0 250px 20px #473C78; }  to { -webkit-box-shadow: 0 0 100px 15px #F72A3B; } } @-moz-keyframes  one { from { -moz-box-shadow: 0 0 250px 20px #473C78; }  to { -moz-box-shadow: 0 0 100px 15px #F72A3B; } } @-o-keyframes  one { from { -o-box-shadow: 0 0 250px 20px #473C78; }  to { -o-box-shadow: 0 0 100px 15px #F72A3B; } }  @keyframes  one { from { box-shadow: 0 0 250px 20px #473C78; }  to {box-shadow: 0 0 100px 15px #F72A3B; } }  #two { width: 90%;  -webkit-animation: two 4s ease-in-out infinite alternate; -moz-animation: two 4s ease-in-out infinite alternate; -ms-animation: two 4s ease-in-out infinite alternate; -o-animation: two 4s ease-in-out infinite alternate; animation: two 4s ease-in-out infinite alternate; } @-webkit-keyframes  two { from { -webkit-box-shadow: 0 0 250px 20px #18C499; }  to { -webkit-box-shadow: 0 0 100px 15px #D8F05E; } } @-moz-keyframes  two { from { -moz-box-shadow: 0 0 250px 20px #18C499; }  to { -moz-box-shadow: 0 0 100px 15px #D8F05E; } } @-o-keyframes  two { from { -o-box-shadow: 0 0 250px 20px #18C499; }  to { -o-box-shadow: 0 0 100px 15px #D8F05E; } }  @keyframes  two { from { box-shadow: 0 0 250px 20px #18C499; }  to { box-shadow: 0 0 100px 15px #D8F05E; } }  #three { width: 80%; -webkit-animation: three 3s ease-in-out infinite alternate; -moz-animation: three 3s ease-in-out infinite alternate; -ms-animation: three 3s ease-in-out infinite alternate; -o-animation: three 3s ease-in-out infinite alternate; animation: three 3s ease-in-out infinite alternate; } @-webkit-keyframes  three { from { -webkit-box-shadow: 0 0 250px 20px #FFDD00; }  to { -webkit-box-shadow: 0 0 100px 15px #3E33FF; } } @-moz-keyframes  three { from { -moz-box-shadow: 0 0 250px 20px #FFDD00; }  to { -moz-box-shadow: 0 0 100px 15px #3E33FF } } @-o-keyframes  three { from { -o-box-shadow: 0 0 250px 20px #FFDD00; }  to { -o-box-shadow: 0 0 100px 15px #3E33FF } }  @keyframes  three { from { box-shadow: 0 0 250px 20px #FFDD00; }  to { box-shadow: 0 0 100px 15px #3E33FF } }  #four { width: 70%; -webkit-animation: four 2s ease-in-out infinite alternate; -moz-animation: four 2s ease-in-out infinite alternate; -ms-animation: four 2s ease-in-out infinite alternate; -o-animation: four 2s ease-in-out infinite alternate; animation: four 2s ease-in-out infinite alternate; } @-webkit-keyframes  four { from { -webkit-box-shadow: 0 0 250px 20px #781848; }  to { -webkit-box-shadow: 0 0 100px 15px #F2BBE9; } } @-moz-keyframes  four { from { -moz-box-shadow: 0 0 250px 20px #781848; }  to { -moz-box-shadow: 0 0 100px 15px #F2BBE9; } } @-o-keyframes  four { from { -o-box-shadow: 0 0 250px 20px #781848; }  to { -o-box-shadow: 0 0 100px 15px #F2BBE9; } }  @keyframes four { from { shadow: 0 0 250px 20px #781848; } to { shadow: 0 0 100px 15px #F2BBE9; } }  #five { width: 60%;  -webkit-animation: five 1s ease-in-out infinite alternate; -moz-animation: five 1s ease-in-out infinite alternate; -ms-animation: five 1s ease-in-out infinite alternate; -o-animation: five 1s ease-in-out infinite alternate; animation: five 1s ease-in-out infinite alternate; } @-webkit-keyframes  five { from { -webkit-box-shadow: 0 0 250px 20px #42F2A1; }  to { -webkit-box-shadow: 0 0 100px 15px #F4F6AD; } } @-moz-keyframes  five { from { -moz-box-shadow: 0 0 250px 20px #42F2A1; }  to { -moz-box-shadow: 0 0 100px 15px #F4F6AD; } } @-o-keyframes  five { from { -o-box-shadow: 0 0 250px 20px #42F2A1; }  to { -o-box-shadow: 0 0 100px 15px #F4F6AD; } }  @keyframes  five { from { box-shadow: 0 0 250px 20px #42F2A1; }  to { box-shadow: 0 0 100px 15px #F4F6AD; } } .stack { display: grid; grid-template-columns: 1fr; } .stack span { font-weight: 400; grid-row-start: 1; grid-column-start: 1; font-size: 35px; --stack-height: calc(100% / var(--stacks) - 1px); --inverse-index: calc(calc(var(--stacks) - 1) - var(--index)); --clip-top: calc(var(--stack-height) * var(--index)); --clip-bottom: calc(var(--stack-height) * var(--inverse-index)); clip-path: inset(var(--clip-top) 0 var(--clip-bottom) 0); animation: stack 340ms cubic-bezier(.46,.29,0,1.24) 1 backwards calc(var(--index) * 120ms), glitch 2s ease infinite 2s alternate-reverse; } .stack span:nth-child(odd) { --glitch-translate: 8px; } .stack span:nth-child(even) { --glitch-translate: -8px; } @keyframes stack { 0% { opacity: 0; transform: translateX(-50%); text-shadow: -2px 3px 0 red, 2px -3px 0 blue; }; 60% { opacity: 0.5; transform: translateX(50%); } 80% { transform: none; opacity: 1; text-shadow: 2px -3px 0 red, -2px 3px 0 blue; } 100% { text-shadow: none; } } @keyframes glitch { 0% { text-shadow: -2px 3px 0 red, 2px -3px 0 blue; transform: translate(var(--glitch-translate)); } 2% { text-shadow: 2px -3px 0 red, -2px 3px 0 blue; } 4%, 100% {  text-shadow: none; transform: none; } }",
        "js": "",
        "nameHtml": "<div class='stack' style='--stacks: 3;'><span style='--index: 0;'>[MUSICIAN_NAME]</span><span style='--index: 1;'>[MUSICIAN_NAME]</span><span style='--index: 2;'>[MUSICIAN_NAME]</span></div>",
        "nameStyle": "",
    },
    {
        "id": "DONGUK",
        "html": "<div id='cloud'><div id='cloud_layer1'></div><div id='cloud_layer2'></div></div>",
        "css": `
        #cloud div::before,
        #cloud div::after {
        content: "";
        display: block;
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-image: url(https://raw.githubusercontent.com/happy358/misc/main/image/cloud_X.png);
        background-repeat: repeat-x;
        animation: cloud var(--duration) linear infinite forwards var(--direction);

        --posX: right;
        --duration: 15s;
        --direction: normal; /* normal or reverse */
        --lowHeight: 20vh;
        --highHeight: 100vh;
        --layerNum: 4;
        --index: 0;
        --opacity: 0.7;
        --moveX: 300px;
        animation-delay: calc(
            (var(--duration) / var(--layerNum)) * var(--index) * -1
        );
        opacity: 0;
        }
        #cloud div::before {
        --index: 0;
        }
        #cloud div::after {
        --index: 2;
        transform: scale3d(-1, 1, 1); /*左右反転*/
        }
        #cloud div#cloud_layer2::before,
        #cloud div#cloud_layer2::after {
        background-image: url(https://raw.githubusercontent.com/happy358/misc/main/image/cloud.png);
        }
        #cloud div#cloud_layer2::before {
        --index: 3;
        }
        #cloud div#cloud_layer2::after {
        --index: 1;
        }
        main {
        position: relative;
        }
        section {
        position: relative;
        width: 100vw;
        min-height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
        }
        figure {
        margin: 3rem 0;
        font-size: 0.7em;
        color: #555;
        }
        figure img {
        width: clamp(100px, 50vw, 300px);
        border-radius: 10px;
        filter: drop-shadow(3px 4px 2px rgba(0, 0, 0, 0.2));
        background-color: lightgray;
        }
        figure a {
        text-decoration: none;
        color: #555;
        }

        .arrow {
        width: auto;
        height: auto;
        position: absolute;
        bottom: 1rem;
        text-align: center;
        mix-blend-mode: overlay;
        }
        .arrow .dot {
        --dotSize: 0.45rem;
        --dotColor: black;
        background: var(--dotColor);
        border-radius: 50%;
        width: var(--dotSize);
        height: var(--dotSize);
        margin: calc(var(--dotSize) * 0.5) 0;
        animation: arrow 2s infinite linear;
        }
        @keyframes arrow {
        0% {
            opacity: 0;
        }
        40% {
            opacity: 1;
        }
        80% {
            opacity: 0;
        }
        100% {
            opacity: 0;
        }
        }
        .arrow div:nth-of-type(1) {
        animation-delay: -0.8s;
        }
        .arrow div:nth-of-type(2) {
        animation-delay: -0.4s;
        }
        .arrow div:nth-of-type(3) {
        animation-delay: 0s;
        }
        .arrow div:nth-of-type(4) {
        animation-delay: 0s;

        width: calc(var(--dotSize) * 3);
        height: calc(var(--dotSize) * 3);
        margin: calc(var(--dotSize) * -1.5) 0 0 calc(var(--dotSize) * -1);
        background: transparent;
        border-radius: 0;
        border: calc(var(--dotSize) * 0.45) solid;
        border-color: transparent transparent var(--dotColor) var(--dotColor);
        transform: rotate(-45deg);
        }
        @keyframes cloud {
        0% {
            opacity: 0;
            background-position: var(--posX) var(--moveX) bottom
            calc(-1 * var(--lowHeight));
            background-size: calc(1 * var(--lowHeight)) var(--lowHeight);
        }
        5% {
            opacity: var(--opacity);
        }
        80% {
            opacity: var(--opacity);
        }
        100% {
            opacity: 0;
            background-position: var(--posX) bottom;
            background-size: calc(3 * var(--highHeight)) var(--highHeight);
        }
        }

        .musicardContainer .name .shimmer {
            font-weight: bold;
            color: rgba(255, 255, 255, 0.1);
            background: linear-gradient(90deg, #fff, #0074D9, #fff);
            background-size: 80% 100%;
            background-repeat: no-repeat;
            background-clip: text;
            -webkit-background-clip: text;
            animation: shimmer 5s infinite;
        }

        @keyframes shimmer {
            0% {
                background-position: -500% 0;
            }
            100% {
                background-position: 500% 0;
            }
        }
        `,
        "js": "",
        "nameHtml": `<span class="shimmer">[MUSICIAN_NAME]</span>`,
        "nameStyle": ``
    },
    {
        "id": "SangjaeBae",
        "html": `<div class="bg"></div><div class="bg bg2"></div><div class="bg bg3"></div>`,
        "css": `
            .bg {
            animation:slide 3s ease-in-out infinite alternate;
            background-image: linear-gradient(-20deg, #2625E5 50%, #000 50%);
            bottom:0;
            left:-100%;
            opacity:.5;
            position:fixed;
            right:-50%;
            top:0;
            z-index:-1;
            }

            .bg2 {
            animation-direction:alternate-reverse;
            animation-duration:8s;
            }

            .bg3 {
            animation-duration:10s;
            }

            @keyframes slide {
            0% {
                transform:translateX(-25%);
            }
            100% {
                transform:translateX(25%);
            }
            }
        `,
        "js": ``,
        "nameHtml": `
        <p id="myText">[MUSICIAN_NAME]</p>
        `,
        "nameStyle": `
            @-webkit-keyframes track-in-out {
            0% {
                letter-spacing: 0.3em;
                opacity: 0;
            }
            20% {
                letter-spacing: normal;
                opacity: 1;
            }
            80% {
                letter-spacing: normal;
                opacity: 1;
            }
            100% {
                letter-spacing: 0.3em;
                opacity: 0;
            }
            }

            #myText{
            white-space: nowrap;
            word-spacing: 10px;
            text-shadow: 2px 2px 5px grey;
            width: 100%;
            animation-name: track-in-out;
            animation-duration: 7s;
            animation-iteration-count: infinite;
            }
        `
    },
    {
        "id": "DohyeopLee",
        "html": `
            <div class='light x1'></div>
            <div class='light x2'></div>
            <div class='light x3'></div>
            <div class='light x4'></div>
            <div class='light x5'></div>
            <div class='light x6'></div>
            <div class='light x7'></div>
            <div class='light x8'></div>
            <div class='light x9'></div>`,
        "css": `
            .light {
                position: absolute;
                width: 0px;
                opacity: .75;
                background-color: white;
                box-shadow: #e9f1f1 0px 0px 20px 2px;
                opacity: 0;
                top: 100vh;
                bottom: 0px;
                left: 0px;
                right: 0px;
                margin: auto;
            }

            .x1{
            -webkit-animation: floatUp 4s infinite linear;
            -moz-animation: floatUp 4s infinite linear;
            -o-animation: floatUp 4s infinite linear;
            animation: floatUp 4s infinite linear;
            -webkit-transform: scale(1.0);
            -moz-transform: scale(1.0);
            -o-transform: scale(1.0);
            transform: scale(1.0);
            }

            .x2{
            -webkit-animation: floatUp 7s infinite linear;
            -moz-animation: floatUp 7s infinite linear;
            -o-animation: floatUp 7s infinite linear;
            animation: floatUp 7s infinite linear;
            -webkit-transform: scale(1.6);
            -moz-transform: scale(1.6);
            -o-transform: scale(1.6);
            transform: scale(1.6);
            left: 15%;
            }

            .x3{
            -webkit-animation: floatUp 2.5s infinite linear;
            -moz-animation: floatUp 2.5s infinite linear;
            -o-animation: floatUp 2.5s infinite linear;
            animation: floatUp 2.5s infinite linear;
            -webkit-transform: scale(.5);
            -moz-transform: scale(.5);
            -o-transform: scale(.5);
            transform: scale(.5);
            left: -15%;
            }

            .x4{
            -webkit-animation: floatUp 4.5s infinite linear;
            -moz-animation: floatUp 4.5s infinite linear;
            -o-animation: floatUp 4.5s infinite linear;
            animation: floatUp 4.5s infinite linear;
            -webkit-transform: scale(1.2);
            -moz-transform: scale(1.2);
            -o-transform: scale(1.2);
            transform: scale(1.2);
            left: -34%;
            }

            .x5{
            -webkit-animation: floatUp 8s infinite linear;
            -moz-animation: floatUp 8s infinite linear;
            -o-animation: floatUp 8s infinite linear;
            animation: floatUp 8s infinite linear;
            -webkit-transform: scale(2.2);
            -moz-transform: scale(2.2);
            -o-transform: scale(2.2);
            transform: scale(2.2);
            left: -57%;
            }

            .x6{
            -webkit-animation: floatUp 3s infinite linear;
            -moz-animation: floatUp 3s infinite linear;
            -o-animation: floatUp 3s infinite linear;
            animation: floatUp 3s infinite linear;
            -webkit-transform: scale(.8);
            -moz-transform: scale(.8);
            -o-transform: scale(.8);
            transform: scale(.8);
            left: -81%;
            }

            .x7{
            -webkit-animation: floatUp 5.3s infinite linear;
            -moz-animation: floatUp 5.3s infinite linear;
            -o-animation: floatUp 5.3s infinite linear;
            animation: floatUp 5.3s infinite linear;
            -webkit-transform: scale(3.2);
            -moz-transform: scale(3.2);
            -o-transform: scale(3.2);
            transform: scale(3.2);
            left: 37%;
            }

            .x8{
            -webkit-animation: floatUp 4.7s infinite linear;
            -moz-animation: floatUp 4.7s infinite linear;
            -o-animation: floatUp 4.7s infinite linear;
            animation: floatUp 4.7s infinite linear;
            -webkit-transform: scale(1.7);
            -moz-transform: scale(1.7);
            -o-transform: scale(1.7);
            transform: scale(1.7);
            left: 62%;
            }

            .x9{
            -webkit-animation: floatUp 4.1s infinite linear;
            -moz-animation: floatUp 4.1s infinite linear;
            -o-animation: floatUp 4.1s infinite linear;
            animation: floatUp 4.1s infinite linear;
            -webkit-transform: scale(0.9);
            -moz-transform: scale(0.9);
            -o-transform: scale(0.9);
            transform: scale(0.9);
            left: 85%;
            }

            @-webkit-keyframes floatUp{
            0%{top: 100vh; opacity: 0;}
            25%{opacity: 1;}
            50%{top: 0vh; opacity: .8;}
            75%{opacity: 1;}
            100%{top: -100vh; opacity: 0;}
            }
            @-moz-keyframes floatUp{
            0%{top: 100vh; opacity: 0;}
            25%{opacity: 1;}
            50%{top: 0vh; opacity: .8;}
            75%{opacity: 1;}
            100%{top: -100vh; opacity: 0;}
            }
            @-o-keyframes floatUp{
            0%{top: 100vh; opacity: 0;}
            25%{opacity: 1;}
            50%{top: 0vh; opacity: .8;}
            75%{opacity: 1;}
            100%{top: -100vh; opacity: 0;}
            }
            @keyframes floatUp{
            0%{top: 100vh; opacity: 0;}
            25%{opacity: 1;}
            50%{top: 0vh; opacity: .8;}
            75%{opacity: 1;}
            100%{top: -100vh; opacity: 0;}
            }

            @-webkit-keyframes fadeIn{
            from{opacity: 0;}
            to{opacity: 1;}
            }

            @-moz-keyframes fadeIn{
            from{opacity: 0;}
            to{opacity: 1;}
            }

            @-o-keyframes fadeIn{
            from{opacity: 0;}
            to{opacity: 1;}
            }

            @keyframes fadeIn{
            from{opacity: 0;}
            to{opacity: 1;}
            }

            @-webkit-keyframes fadeOut{
            0%{opacity: 0;}
            30%{opacity: 1;}
            80%{opacity: .9;}
            100%{opacity: 0;}
            }

            @-moz-keyframes fadeOut{
            0%{opacity: 0;}
            30%{opacity: 1;}
            80%{opacity: .9;}
            100%{opacity: 0;}
            }

            @-o-keyframes fadeOut{
            0%{opacity: 0;}
            30%{opacity: 1;}
            80%{opacity: .9;}
            100%{opacity: 0;}
            }

            @keyframes fadeOut{
            0%{opacity: 0;}
            30%{opacity: 1;}
            80%{opacity: .9;}
            100%{opacity: 0;}
            }

            @-webkit-keyframes finalFade{
            0%{opacity: 0;}
            30%{opacity: 1;}
            80%{opacity: .9;}
            100%{opacity: 1;}
            }

            @-moz-keyframes finalFade{
            0%{opacity: 0;}
            30%{opacity: 1;}
            80%{opacity: .9;}
            100%{opacity: 1;}
            }

            @-o-keyframes finalFade{
            0%{opacity: 0;}
            30%{opacity: 1;}
            80%{opacity: .9;}
            100%{opacity: 1;}
            }

            @keyframes finalFade{
            0%{opacity: 0;}
            30%{opacity: 1;}
            80%{opacity: .9;}
            100%{opacity: 1;}
            }
        `,
        "js": ``,
        "nameHtml": `
            <div class="content">
                <h1>[MUSICIAN_NAME]</h1>
                <h1>[MUSICIAN_NAME]</h1>
            </div>
        `,
        "nameStyle": `
            .content {
            position: relative;
            margin-bottom: 20px;
            }

            .content h1 {
            position: absolute;
            transform: translate(-50%, -50%);
            white-space: nowrap; /* ✅ 자동 줄바꿈 방지 */
            }

            .content h1:nth-child(1) {
            color: transparent;
            -webkit-text-stroke: 1px #67BADE;
            }

            .content h1:nth-child(2) {
            color: #67BADE;
            animation: animate 4s ease-in-out infinite;
            }

            @keyframes animate {
            0%,
            100% {
                clip-path: polygon(
                0% 45%,
                15% 45%,
                32% 50%,
                54% 60%,
                70% 61%,
                84% 59%,
                100% 52%,
                100% 100%,
                0% 100%
                );
            }
            50% {
                clip-path: polygon(
                0 60%,
                16% 65%,
                34% 66%,
                51% 62%,
                67% 50%,
                84% 45%,
                100% 46%,
                100% 100%,
                0% 100%
                );
            }
            }
        `
    },
    {
        "id": "SerA",
        "html": `<div class="landscape"></div><div class="filter"></div><canvas id="canvas"></canvas>`,
        "css": `
        .canvas {
		  margin: 0;
		  overflow: hidden;
		  width: 100%;
		  height: 100%;
		  cursor: none;
		}
		.filter {
		  width: 100%;
		  height: 100%;
		  position: absolute;
		  top: 0;
		  left: 0;
		  background: #071434;
		  animation: colorChange 30s ease-in-out infinite;
		  animation-fill-mode: both;
		  mix-blend-mode: overlay;
		}
		@keyframes colorChange {
		  0%,
		  100% {
		    opacity: 0;
		  }
		  50% {
		    opacity: .9;
		  }
		}
		.landscape {
		  position: absolute;
		  bottom: 0px;
		  left: 0;
		  width: 100%;
		  height: 100%;
		  background-image: url(https://openclipart.org/image/2400px/svg_to_png/250847/Trees-Landscape-Silhouette.png);
		  background-size: 1000px 250px;
		  background-repeat: repeat-x;
		  background-position: center bottom;
		}
        `,
        "js": "setTimeout(() => { customScript(); }, 200); var params = { backgroundSpeed: 10 }; function Star(id, x, y) { this.id = id; this.x = x; this.y = y; this.r = Math.floor(Math.random() * 2) + 1; var alpha = (Math.floor(Math.random() * 10) + 1) / 10 / 2; this.color = 'rgba(255,255,255,' + alpha + ')'; } Star.prototype.draw = function () { ctx.fillStyle = this.color; ctx.shadowBlur = this.r * 2; ctx.beginPath(); ctx.arc(this.x, this.y, this.r, 0, 2 * Math.PI, false); ctx.closePath(); ctx.fill(); }; Star.prototype.move = function () { this.y -= 0.15 + params.backgroundSpeed / 100; if (this.y <= -10) this.y = HEIGHT + 10; this.draw(); }; function customScript() { var canvas = document.getElementById('canvas'); if (!canvas) return; ctx = canvas.getContext('2d'); WIDTH = document.documentElement.clientWidth; HEIGHT = document.documentElement.clientHeight; canvas.setAttribute('width', WIDTH); canvas.setAttribute('height', HEIGHT); var stars = []; var initStarsPopulation = 80; for (var i = 0; i < initStarsPopulation; i++) { stars[i] = new Star(i, Math.floor(Math.random() * WIDTH), Math.floor(Math.random() * HEIGHT)); } function animate() { ctx.clearRect(0, 0, WIDTH, HEIGHT); for (var i in stars) { stars[i].move(); } requestAnimationFrame(animate); } animate(); }",
        "nameHtml": `<div class="txt" contenteditable="true">[MUSICIAN_NAME]</div>`,
        "nameStyle": `
            .txt {
            animation: netflix_style 7s infinite;
            outline: none;
            white-space: nowrap;
            }
            @keyframes netflix_style {
            0% {
                text-shadow: 
                1px 1px #aaa, 
                2px 2px #aaa, 
                3px 3px #aaa, 
                4px 4px #aaa, 
                5px 5px #aaa;
                color: #f3f3f3;
                transform: scale(1.5, 1.5);
            }
            10% {
                text-shadow: 
                1px 1.5px #aaa, 
                2px 3px #aaa, 
                3px 4.5px #aaa, 
                4px 6px #aaa, 
                5px 7.5px #aaa;
                color: #f3f3f3;
                transform: scale(1.5, 1.5);
            }
            15% {
                color: #f3f3f3;
            }
            20% {
                color: #f3f3f3;
                text-shadow: none;
                transform: scale(1.1, 1.1);
            }
            75% {
                opacity: 1;
            }
            80% {
                opacity: 0;
                color: #f3f3f3;
                transform: scale(0.85, 0.9);
            }
            100% {
                opacity: 0;
            }
            }
        `
    },
    {
        "id": "Dalzabi",
        "html": `<div class="background-container"><img class="moon-image" src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/1231630/moon2.png" alt=""><div class="stars"></div><div class="twinkling"></div><div class="clouds"></div>`,
        "css": `
            @keyframes move-background {
            from {
                -webkit-transform: translate3d(0px, 0px, 0px);
            }
            to {
                -webkit-transform: translate3d(1000px, 0px, 0px);
            }
            }
            @-webkit-keyframes move-background {
            from {
                -webkit-transform: translate3d(0px, 0px, 0px);
            }
            to {
                -webkit-transform: translate3d(1000px, 0px, 0px);
            }
            }
            @-moz-keyframes move-background {
            from {
                -webkit-transform: translate3d(0px, 0px, 0px);
            }
            to {
                -webkit-transform: translate3d(1000px, 0px, 0px);
            }
            }
            @-webkit-keyframes move-background {
            from {
                -webkit-transform: translate3d(0px, 0px, 0px);
            }
            to {
                -webkit-transform: translate3d(1000px, 0px, 0px);
            }
            }
            .background-container {
            position: fixed;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            }
            .stars {
            background: black url(https://s3-us-west-2.amazonaws.com/s.cdpn.io/1231630/stars.png) repeat;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            display: block;
            z-index: 0;
            }
            .twinkling {
            filter: hue-rotate(290deg) brightness(1.5) saturate(1.4);
            width: 10000px;
            height: 100%;
            background: transparent url("https://s3-us-west-2.amazonaws.com/s.cdpn.io/1231630/twinkling.png") repeat;
            background-size: 1000px 1000px;
            position: absolute;
            right: 0;
            top: 0;
            bottom: 0;
            z-index: 2;
            -moz-animation: move-background 70s linear infinite;
            -ms-animation: move-background 70s linear infinite;
            -o-animation: move-background 70s linear infinite;
            -webkit-animation: move-background 70s linear infinite;
            animation: move-background 70s linear infinite;
            }
            .clouds {
            filter: sepia(10%) hue-rotate(290deg) brightness(1.0) saturate(1.5);
            width: 10000px;
            height: 100%;
            background: transparent url("https://s3-us-west-2.amazonaws.com/s.cdpn.io/1231630/clouds_repeat.png") repeat;
            background-size: 1000px 1000px;
            position: absolute;
            right: 0;
            top: 0;
            bottom: 0;
            z-index: 3;
            -moz-animation: move-background 150s linear infinite;
            -ms-animation: move-background 150s linear infinite;
            -o-animation: move-background 150s linear infinite;
            -webkit-animation: move-background 150s linear infinite;
            animation: move-background 150s linear infinite;
            }
            .moon-image {
            filter: sepia(30%) hue-rotate(290deg) brightness(1.0) saturate(1.5);
            width: 70vh;
            position: absolute;
            z-index: 3;
            right: 20px;
            }
        `,
        "js": ``,
        "nameHtml": `<div class="waviy">
            <span style="--i:1">D</span>
            <span style="--i:2">a</span>
            <span style="--i:3">l</span>
            <span style="--i:4">z</span>
            <span style="--i:5">a</span>
            <span style="--i:6">b</span>
            <span style="--i:7">i</span>
            </div>
        `,
        "nameStyle": `
            .waviy {
            position: relative;
            }
            .waviy span {
            position: relative;
            display: inline-block;
            font-size: 40px;
            color: #fff;
            animation: flip 2s infinite;
            animation-delay: calc(.2s * var(--i))
            }
            @keyframes flip {
            0%,80% {
                transform: rotateY(360deg) 
            }
            }
        `
    },
    {
        "id": "HAEJIN",
        "html": `<div id="app"><canvas id="webgl-canvas"></canvas></div>`,
        "css": `
            #app {
            margin: 0;
            width: 100%;
            height: 100%;
            }
            #app {
            overflow: hidden;
            touch-action: pan-up;
            color: #ffffff;
            display: flex;
            justify-content: center;
            align-items: center;
            }
            #app a {
            text-decoration: none;
            color: #fff;
            }
            #app canvas {
            display: block;
            position: fixed;
            top: 0;
            width: 100%;
            height: 100%;
            z-index: -1;
            }
        `,
        "js": `
            setTimeout(() => {
                (async function() {
                    const { Bokeh1Background } = await import('https://cdn.jsdelivr.net/npm/threejs-components@0.0.2/build/backgrounds/bokeh1.cdn.min.js');

                    const bokeh1Background = Bokeh1Background(document.getElementById('webgl-canvas'));
                    bokeh1Background.loadMap('https://cdn.jsdelivr.net/npm/threejs-components@0.0.2/build/assets/bokeh-particles2.png');
                    bokeh1Background.setColors([0x6d4862, 0xfd826c, 0x22ccc1]);

                    document.body.addEventListener('click', () => {
                    bokeh1Background.setColors([0xffffff * Math.random(), 0xffffff * Math.random(), 0xffffff * Math.random()]);
                    });
                })();
            }, 100);
            
        `,
        "nameHtml": `<div class="sticky-text"><h1>[MUSICIAN_NAME]</h1></div>`,
        "nameStyle": `
            .sticky-text h1 {
            position: relative;
            user-select: none;
            animation: gooey 5s infinite alternate;
            transition: transform 0.2s; /* Smooth transition for hover effect */
            }
            @keyframes gooey {
            0% {
                letter-spacing: 1;
                transform: scale(1);
            }
            50% {
                letter-spacing: -3px;
                transform: scale(0.90);
            }
            100% {
                letter-spacing: 1;
                transform: scale(1);
            }
            }
            .sticky-text h1:hover {
            animation: bounce 0.5s infinite alternate; /* Bounce effect on hover */
            }
            @keyframes bounce {
            0% {
                transform: translateY(0);
            }
            30% {
                transform: translateY(-5px);
            }
            50% {
                transform: translateY(-3px);
            }
            70% {
                transform: translateY(-5px);
            }
            100% {
                transform: translateY(0);
            }
            }
        `
    },
    {
        "id": "E.Jean",
        "html": `<div class="container"></div><div class="noise"></div>`,
        "css": `
            .container {
                width: 100vw; /* 전체 너비 */
                height: 100vh; /* 전체 높이 */
                
                background: url("https://image.freepik.com/free-photo/3d-render-of-spotlights-on-a-grunge-brick-wall_1048-6284.jpg");
                background-repeat: repeat-x; /* 좌우 반복, 상하 반복 금지 */
                background-size: auto 100%; /* 너비는 원본 유지, 높이는 100% 맞춤 */
                background-position: top center; /* 배경을 상단 중앙 정렬 */
                
                position: fixed; /* 스크롤해도 고정 */
                top: 0;
                left: 0;
                z-index: -1; /* 배경 뒤로 보내기 */
                filter: brightness(1.2) sepia(0.5) contrast(1.1);
            }
            .noise {
            content: "";
            z-index: 100;
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: url(https://s3-us-west-2.amazonaws.com/s.cdpn.io/608091/noise.png);
            -webkit-animation: 1s infinite noise;
                    animation: 1s infinite noise;
            pointer-events: none;
            z-index: 0;
            }
            @-webkit-keyframes noise {
            0%, 100% {
                background-position: 0 0;
            }
            10% {
                background-position: -5% -10%;
            }
            20% {
                background-position: -15% 5%;
            }
            30% {
                background-position: 7% -25%;
            }
            40% {
                background-position: 20% 25%;
            }
            50% {
                background-position: -25% 10%;
            }
            60% {
                background-position: 15% 5%;
            }
            70% {
                background-position: 0% 15%;
            }
            80% {
                background-position: 25% 35%;
            }
            90% {
                background-position: -10% 10%;
            }
            }
            @keyframes noise {
            0%, 100% {
                background-position: 0 0;
            }
            10% {
                background-position: -5% -10%;
            }
            20% {
                background-position: -15% 5%;
            }
            30% {
                background-position: 7% -25%;
            }
            40% {
                background-position: 20% 25%;
            }
            50% {
                background-position: -25% 10%;
            }
            60% {
                background-position: 15% 5%;
            }
            70% {
                background-position: 0% 15%;
            }
            80% {
                background-position: 25% 35%;
            }
            90% {
                background-position: -10% 10%;
            }
            }
        `,
        "js": `
        `,
        "nameHtml": `<div class="light effect"><div>E.<span>J</span>ea<span>n</span></div></div>`,
        "nameStyle": `
            .light{
            font-size: 35px;
            color: #fc6122;
            text-align: center;
            z-index: 1;
            }
            .effect{
            text-shadow: 
                0 -40px 80px,
                0 0 2px,
                0 0 1em #fc6122,
                0 0 .6em #fc6122,
                0 0 1.2em #fc6122,
                0 9px 4px #000;
            }
            .light span{
            animation: on-off 1s infinite linear;
            }
            .light span:nth-child(2){
            animation-delay: 0.5s;
            }
            @keyframes on-off{
            69%{
                text-shadow: inherit;
                color: inherit;
            }
            70%{
                color: #333;
            }
            71%{
                text-shadow: none;
            }
            73%{
                text-shadow: inherit;
                color: inherit;
            }
            74%{
                text-shadow: none;
                color: #333;
            }
            75%{
                text-shadow: inherit;
                color: inherit;
            }
            90%{
                text-shadow: none;
                color: #333;
            }
            90.5%{
                text-shadow: inherit;
                color: inherit;
            }
            
            }
        `
    },
    {
        "id": "Comytru",
        "html": `<div class='stars'></div><div class='twinkling'></div><div class='clouds'></div>
        `,
        "css": `
        .stars,
        .twinkling,
        .clouds {
          position: absolute;
          display: block;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          width: 100%;
          height: 100%;
        }
        
        .stars {
          z-index: 0;
          background: #000 url("https://i.imgur.com/YKY28eT.png") repeat top center;
        }
        
        .twinkling {
          z-index: 1;
          background: transparent url("https://i.imgur.com/XYMF4ca.png") repeat top center;
          animation: move-twink-back 200s linear infinite;
        }
        
        .clouds {
          z-index: 2;
          background: transparent url("https://i.imgur.com/mHbScrQ.png") repeat top center;
          animation: move-clouds-back 200s linear infinite;
        }
        
        @keyframes move-twink-back {
          from {
            background-position: 0 0;
          }
          to {
            background-position: -10000px 5000px;
          }
        }
        @keyframes move-clouds-back {
          from {
            background-position: 0 0;
          }
          to {
            background-position: 10000px 0;
          }
        }
        `,
        "js": `
        `,
        "nameHtml": `<div class="spinner-box"><h1>[MUSICIAN_NAME]</h1>
            <div class="blue-orbit leo"></div>
            <div class="green-orbit leo"></div>
            <div class="red-orbit leo"></div>
            <div class="white-orbit w1 leo"></div>
            <div class="white-orbit w2 leo"></div>
            <div class="white-orbit w3 leo"></div>
        </div>`,
        "nameStyle": `
        .spinner-box {
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: transparent;
        z-index: 2; /* 가장 상단 레이어 배치 */
        }

        .leo {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        }

        .blue-orbit {
        width: 165px;
        height: 165px;
        border: 1px solid #91daffa5;
        -webkit-animation: spin3D 3s linear .2s infinite;
        }

        .green-orbit {
        width: 120px;
        height: 120px;
        border: 1px solid #91ffbfa5;
        -webkit-animation: spin3D 2s linear 0s infinite;
        }

        .red-orbit {
        width: 90px;
        height: 90px;
        border: 1px solid #ffca91a5;
        -webkit-animation: spin3D 1s linear 0s infinite;
        }

        .white-orbit {
        width: 60px;
        height: 60px;
        border: 2px solid #ffffff;
        -webkit-animation: spin3D 10s linear 0s infinite;
        }

        .w1 {
        transform: rotate3D(1, 1, 1, 90deg);
        }

        .w2 {
        transform: rotate3D(1, 2, .5, 90deg);
        }

        .w3 {
        transform: rotate3D(.5, 1, 2, 90deg);
        }

        @keyframes spin3D {
        from {
            transform: rotate3d(.5,.5,.5, 360deg);
        }
        to {
            transform: rotate3d(0deg);
        }
        }
        `
    },
    {
        "id": "CHRK",
        "html": "<div id='holder'></div><div class='lightning'></div><div class='box'></div>",
        "css": "",
        "js": "",
        "nameHtml": `<div class="wrap"><span class="letter">청</span><span class="letter">록</span><span class="space"></span><span class="letter">C</span><span class="letter">H</span><span class="letter">R</span><span class="letter">K</span></div>
        `,
        "nameStyle": `
          .wrap {
            max-width: 960px;
            position: relative;
            transform-style: preserve-3d;
            text-align: center;
          }
          
          .letter, .space {
            display: inline-block;
            text-transform: uppercase;
            position: relative;
            transform-style: preserve-3d;
            text-shadow: 2px 2px 5px black;
          }
          
          .space {
            width: 0.5em;
          }
          
          @-webkit-keyframes anim1 {
            0% {
              transform: translate3d(808px, 994px, -1000px) rotate(0deg);
              opacity: 0;
            }
            100% {
              transform: translate3d(0, 0, 0) rotate(360deg);
              opacity: 0.8;
            }
          }
          
          @keyframes anim1 {
            0% {
              transform: translate3d(808px, 994px, -1000px) rotate(0deg);
              opacity: 0;
            }
            100% {
              transform: translate3d(0, 0, 0) rotate(360deg);
              opacity: 0.8;
            }
          }
          .letter:nth-child(1) {
            -webkit-animation: anim1 5s;
                    animation: anim1 5s;
            -webkit-animation-delay: -0.2s;
                    animation-delay: -0.2s;
          }
          
          @-webkit-keyframes anim2 {
            0% {
              transform: translate3d(315px, 949px, -1000px) rotate(0deg);
              opacity: 0;
            }
            100% {
              transform: translate3d(0, 0, 0) rotate(360deg);
              opacity: 0.8;
            }
          }
          
          @keyframes anim2 {
            0% {
              transform: translate3d(315px, 949px, -1000px) rotate(0deg);
              opacity: 0;
            }
            100% {
              transform: translate3d(0, 0, 0) rotate(360deg);
              opacity: 0.8;
            }
          }
          .letter:nth-child(2) {
            -webkit-animation: anim2 5s;
                    animation: anim2 5s;
            -webkit-animation-delay: -0.4s;
                    animation-delay: -0.4s;
          }
          
          @-webkit-keyframes anim3 {
            0% {
              transform: translate3d(-1185px, -797px, -1000px) rotate(0deg);
              opacity: 0;
            }
            100% {
              transform: translate3d(0, 0, 0) rotate(-360deg);
              opacity: 0.8;
            }
          }
          
          @keyframes anim3 {
            0% {
              transform: translate3d(-1185px, -797px, -1000px) rotate(0deg);
              opacity: 0;
            }
            100% {
              transform: translate3d(0, 0, 0) rotate(-360deg);
              opacity: 0.8;
            }
          }
          .letter:nth-child(3) {
            -webkit-animation: anim3 5s;
                    animation: anim3 5s;
            -webkit-animation-delay: -0.6s;
                    animation-delay: -0.6s;
          }
          
          @-webkit-keyframes anim4 {
            0% {
              transform: translate3d(-422px, -800px, -1000px) rotate(0deg);
              opacity: 0;
            }
            100% {
              transform: translate3d(0, 0, 0) rotate(-360deg);
              opacity: 0.8;
            }
          }
          
          @keyframes anim4 {
            0% {
              transform: translate3d(-422px, -800px, -1000px) rotate(0deg);
              opacity: 0;
            }
            100% {
              transform: translate3d(0, 0, 0) rotate(-360deg);
              opacity: 0.8;
            }
          }
          .letter:nth-child(4) {
            -webkit-animation: anim4 5s;
                    animation: anim4 5s;
            -webkit-animation-delay: -0.8s;
                    animation-delay: -0.8s;
          }
          
          @-webkit-keyframes anim5 {
            0% {
              transform: translate3d(465px, 826px, -1000px) rotate(0deg);
              opacity: 0;
            }
            100% {
              transform: translate3d(0, 0, 0) rotate(360deg);
              opacity: 0.8;
            }
          }
          
          @keyframes anim5 {
            0% {
              transform: translate3d(465px, 826px, -1000px) rotate(0deg);
              opacity: 0;
            }
            100% {
              transform: translate3d(0, 0, 0) rotate(360deg);
              opacity: 0.8;
            }
          }
          .letter:nth-child(5) {
            -webkit-animation: anim5 5s;
                    animation: anim5 5s;
            -webkit-animation-delay: -1s;
                    animation-delay: -1s;
          }
          
          @-webkit-keyframes anim6 {
            0% {
              transform: translate3d(328px, 874px, -1000px) rotate(0deg);
              opacity: 0;
            }
            100% {
              transform: translate3d(0, 0, 0) rotate(360deg);
              opacity: 0.8;
            }
          }
          
          @keyframes anim6 {
            0% {
              transform: translate3d(328px, 874px, -1000px) rotate(0deg);
              opacity: 0;
            }
            100% {
              transform: translate3d(0, 0, 0) rotate(360deg);
              opacity: 0.8;
            }
          }
          .letter:nth-child(6) {
            -webkit-animation: anim6 5s;
                    animation: anim6 5s;
            -webkit-animation-delay: -1.2s;
                    animation-delay: -1.2s;
          }
          
          @-webkit-keyframes anim7 {
            0% {
              transform: translate3d(376px, 988px, -1000px) rotate(0deg);
              opacity: 0;
            }
            100% {
              transform: translate3d(0, 0, 0) rotate(360deg);
              opacity: 0.8;
            }
          }
          
          @keyframes anim7 {
            0% {
              transform: translate3d(376px, 988px, -1000px) rotate(0deg);
              opacity: 0;
            }
            100% {
              transform: translate3d(0, 0, 0) rotate(360deg);
              opacity: 0.8;
            }
          }
          .letter:nth-child(7) {
            -webkit-animation: anim7 5s;
                    animation: anim7 5s;
            -webkit-animation-delay: -1.4s;
                    animation-delay: -1.4s;
          }
        `
    },
    {
        "id": "JELLO",
        "html": "",
        "css": "",
        "js": "",
        "nameHtml": "<div class='name-box'><h1>[MUSICIAN_NAME]</h1></div>",
        "nameStyle": `
          .name-box {
            text-shadow: 2px 2px 5px pink; /* x, y, 블러 정도, 그림자 색상 */
            }
        `
    },
    {
        "id": "Kosmoz",
        "html": "",
        "css": `

        `,
        "js": "",
        "nameHtml": "<div class='box'><p class='text'>[MUSICIAN_NAME]</p></div>",
        "nameStyle": `
            .box{
            margin: 0 auto 0 auto;
            background-color: black;
            color: white !important;
            height: auto;
            width: 220px;
            text-align: center;
            text-transform: uppercase;
            -moz-transform: skew(-10deg);
            -webkit-transform: skew(-10deg);
            -o-transform: skew(-10deg);
            transform: skew(-10deg);
            }

            .box .text{
            letter-spacing: 6px;  
            }

            .text{
            padding: 10px 0;
            font-size: 30px;
            color: white !important;
            }
        `
    },
    {
        "id": "ShamRock",
        "html": "",
        "css": `
            .normal-fade {
            animation: fade 5s forwards;
            }

            .counter-fade {
            animation: fade-counter 4s forwards;
            }

            @keyframes fade {
            0% { 
                opacity: 1;    
            } 
            
            2% {
                transform: scale(1.3);
            }
            
            100%{
                opacity: 0; 
                transform: translateY(1000px) scale(0.5) rotate(200deg);
            }  
            }

            @keyframes fade-counter {
            0% { 
                opacity: 1;    
            } 
            
            2% {
                transform: scale(0.5);
            }  
            
            100%{
                opacity: 0; 
                transform: translateY(1000px) scale(1) rotate(-300deg);
            }  
            }
        `,
        "js": `
            document.addEventListener('click', showShamrock);

            function showShamrock(event){
            var posX = event.pageX;
            var posY = event.pageY;
            
            createShamrock(posX, posY, randomShamrock(), randomClass(), randomGreen()); 
            
            
            var svgs = document.getElementsByTagName('svg');  
            if(svgs.length > 50){
                for (i = svgs.length - 1; i >= 0; i--) {
                svgs[i].parentNode.removeChild(svgs[i]);
                }
            }
            
            }

            function randomGreen(){
            var greens = ['#66a841', '#7ba237', '#95eb00', '#00b842', '#4caf50', '#56B949', '#C1CCAE', '#03d1ab', '#8DC0B1', '#B2EDCE', '#88C542', '#a6cb62', '#47cb4a', '#9BF14F', '#6b7d27', '#4caf50', '#00be70', '#207720', '#86c036'];
            var random = Math.floor(Math.random() * (greens.length - 1 + 1)) + 0;
            var green = greens[random];
            // console.log(random, green);
            return green;
            }

            function randomClass(){
            var animClass = ['normal-fade','counter-fade'];
            var random = Math.floor(Math.random() * (animClass.length - 1 + 1)) + 0;
            return animClass[random];
            }

            function randomShamrock(){
            var shamrockList = [
                {
                'width': 111.994,
                'height': 110.637,
                'viewBox': "0 0 111.994 110.637",
                'd': 'M111.462,65.159c2.263-13.032-15.935-19.88-25.183-21.101c11.188-11.163,15.355-38.708-8.668-31.884c-7.935-27.668-30.969-1.793-32.394,14.748C34.472,15.305,4.875,9,12.046,34.245c-26.144,7.497-3.973,29.846,12.314,32.113C13.096,77.463,8.66,105.296,32.845,98.426c8.066,28.13,31.356,1.1,32.455-15.587c6.062,6.934,21.552,18.087,31.092,9.219c3.879-4.685,4.791-9.955,2.736-15.811C105.424,74.862,109.536,71.167,111.462,65.159C113.023,56.169,110.558,70.376,111.462,65.159z'
                },
                {
                'width': 215.864,
                'height': 234.908,
                'viewBox': "0 0 215.864 234.908",
                'd': "M215.141,117.341c3.291-25.531-30.435-37.346-50.109-36.702c20.565-21.12,21.139-82.684-19.291-54.5c-8.249-53.786-59.09-13.651-59.853,22.91C65.84,22.042,19.937,19.389,31.183,63.042c-58.854-1.868-23.982,66.436,19.115,67.457c-31.552,25.345-29.373,50.841,8.254,55.072c-3.511,55.13,52.971,18.657,59.89-14.906c7.204,19.541-15.156,42.589-9.872,57.707c7.312,20.926,20.941-15.131,20.858-14.653c3.351-19.336-1.521-36.422,0.143-54.847c15.044-2.052,41.946,45.009,63.252,14.188c7.172-10.371,1.271-22.031-1.28-32.563C202.365,137.243,213.57,129.531,215.141,117.341C217.319,100.446,213.747,128.157,215.141,117.341z"
                },
            ];
            
            var random = Math.floor(Math.random() * (shamrockList.length - 1 + 1)) + 0;
            return shamrockList[random];
            }

            function createShamrock(x, y, shape, animation, fill){
                var shamrock = document.createElementNS("http://www.w3.org/2000/svg","svg");
                shamrock.setAttribute('width', shape.width + 'px');
                shamrock.setAttribute('height', shape.height + 'px');
                shamrock.setAttribute('class', animation);
                shamrock.setAttribute('viewBox', shape.viewBox);
                shamrock.setAttribute('fill', fill);
                shamrock.style.position = 'absolute';
                shamrock.style.top = (y - (shape.height / 2)) + 'px';
                shamrock.style.left = (x - (shape.width / 2)) + 'px';
                var svgNS = shamrock.namespaceURI;
                var path = document.createElementNS(svgNS, 'path');
                path.setAttribute ('d', shape.d);
                shamrock.appendChild(path);

                const customBackground = document.querySelector('.musicardContainer .customBackground');
                if (customBackground) {
                    customBackground.appendChild(shamrock);  
                }
            }

        `,
        "nameHtml": "<div class='name-box'><h1>[MUSICIAN_NAME]</h1></div>",
        "nameStyle": `
            .name-box {
            position: relative;
            display: inline-block;
            /* 기존 변수 정의는 그대로 유지 */
            --width: 34px;
            --height: 34px;
            --pixel-s: calc(var(--width) * 0.34);
            --pixel-m: calc(var(--width) * 0.89);
            }

            /* 가운데 정렬 대신 왼쪽 정렬 */
            .name-box::before,
            .name-box::after {
            content: '';
            position: absolute;
            top: 50%;
            right: -3%;                      /* ← 왼쪽 0px */
            width: var(--width);
            height: var(--height);
            transform: translateY(-50%);  /* ← 수직 중앙만 유지 */
            border-radius: 50%;
            box-shadow:
                var(--pixel-s) var(--pixel-s) 0 #51b566,
                var(--pixel-m) var(--pixel-s) 0 #68bc6c,
                var(--pixel-s) var(--pixel-m) 0 #68bc6c;
            opacity: .50;
            animation: anim 4s linear infinite;
            }

            .name-box::before {
            animation-delay: 1s;
            animation-timing-function: cubic-bezier(0.470, 0.000, 0.745, 0.715);
            }

            .name-box::after {
            animation-delay: 1.5s;
            animation-timing-function: cubic-bezier(0.390, 0.575, 0.565, 1.000);
            }

            @keyframes anim {
            0% {
                animation-timing-function: linear;
            }
            50% {
                transform: translateY(-50%) scale(.89) rotateZ(360.01deg);
                animation-timing-function: linear;
            }
            51% {
                animation-timing-function: cubic-bezier(0.680, -0.550, 0.265, 1.550);
            }
            100% {
                transform: translateY(-50%) rotateZ(360.01deg);
            }
            }
        `
    },
]

export default customBackgroundByUser;